import { useUser } from "MVVM/Hooks/useUser";

export const useProEditAccess = () => {
  const { allstarUser } = useUser();

  const userGroupType = allstarUser?.user?.userGroup?.type;
  const hasValidUserGroup =
    userGroupType === "INTERNAL" || userGroupType === "CREATOR_PLAT";

  return {
    hasProEditAccess: hasValidUserGroup,
    hasValidUserGroup,
  };
};
